import gql from 'graphql-tag';

const MUTATION_CREATE_USER = gql`
  mutation createUser($input: CreateUserInput!) {
    createUser(input: $input) {
      isSuccess
      message
      user {
        id
        firstName
        lastName
        email
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export default MUTATION_CREATE_USER;
